export const formatDocumentTitle = (...args: string[]) => args.join(' – ');
